import { Stack, styled } from '@mui/material';
import { type ReactNode } from 'react';

export type CurvedBackgroundImageProps = {
    children?: ReactNode;
    image: string;
};

export const CurvedBackgroundImage = ({ children, image }: CurvedBackgroundImageProps) => {
    const RoundedImage = styled(Stack)(({ theme }) => ({
        [theme.breakpoints.up('md')]: {
            position: 'fixed',
            top: 0,
            right: 0,
            width: '40vw',
            height: '100vh',
            backgroundImage: `url(${image})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            zIndex: 0,
            overflow: 'hidden',

            ...(image.includes('bannerZero')
                ? { clipPath: 'none' }
                : {
                      clipPath: `
              ellipse(
                clamp(500px, 45vw, 700px)
                clamp(100vh, 100vh, 100vh)
                at
                clamp(600px, 55vw, 800px)
                50vh
              )
            `,
                      WebkitClipPath: `
              ellipse(
                clamp(500px, 45vw, 700px)
                clamp(100vh, 100vh, 100vh)
                at
                clamp(600px, 55vw, 800px)
                50vh
              )
            `,
                  }),
        },

        [theme.breakpoints.down('md')]: {
            backgroundImage: `url(${image})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            borderBottomLeftRadius: image.includes('bannerZero') ? '0' : '50% 10%',
            borderBottomRightRadius: image.includes('bannerZero') ? '0' : '50% 10%',
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            height: '190px',
            marginBottom: '16px',
            overflow: 'hidden',
            width: '100vw',
            position: 'relative',
        },

        [theme.breakpoints.down('sm')]: {
            backgroundImage: `url(${image})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            borderBottomLeftRadius: image.includes('bannerZero') ? '0' : '50% 12%',
            borderBottomRightRadius: image.includes('bannerZero') ? '0' : '50% 12%',
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            height: '130px',
            marginBottom: '16px',
            overflow: 'hidden',
            width: '100vw',
            position: 'relative',
        },
    }));

    return <RoundedImage>{children}</RoundedImage>;
};
